export const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterDatasetsDraw(chart, args, options) {
    const leftIndicator = document.getElementById('left-indicator');
    const rightIndicator = document.getElementById('right-indicator');
    if (!leftIndicator || !rightIndicator) return;

    // Clear old content
    leftIndicator.innerHTML = '';
    rightIndicator.innerHTML = '';
    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    // Example: First dataset on left, last on right
    if (items.length > 0) {
      const leftItem = items[0];
      const leftLabel = document.createElement('p');
      leftLabel.textContent = leftItem.text;
      leftLabel.style.color = leftItem.fillStyle;
      leftLabel.style.fontWeight = 500;
      leftLabel.style.position = 'absolute';
      leftLabel.style.transform = "rotate(-90deg)";
      leftLabel.style.margin = 0;
      leftIndicator.style.whiteSpace = "nowrap";
      leftIndicator.appendChild(leftLabel);
    }
    if (items.length > 1) {
      const rightItem = items[items.length - 1];
      const rightLabel = document.createElement('p');
      rightLabel.textContent = rightItem.text;
      rightLabel.style.color = rightItem.fillStyle;
      rightLabel.style.fontWeight = 500;
      rightLabel.style.position = 'absolute';
      rightLabel.style.margin = 0;
      rightLabel.style.transform = "rotate(90deg)";
      rightIndicator.style.whiteSpace = "nowrap";
      rightIndicator.appendChild(rightLabel);
    }
  }
};
export const DashedLinesToAxis = {
  id: 'dashedLinesToAxis',
  afterDatasetsDraw(chart, args, pluginOptions) {
    if (chart.config.type !== 'line') return;
    const {
      ctx,
      chartArea: {
        top,
        bottom
      },
      scales: {
        x,
        y
      }
    } = chart;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      chart.getDatasetMeta(datasetIndex).data.forEach((point, index) => {
        const xPos = point.x;
        const yPos = point.y - 0.05;
        ctx.save();
        ctx.setLineDash([3, 5]); // dashed line
        ctx.beginPath();
        ctx.moveTo(xPos, yPos);
        ctx.lineTo(xPos, bottom); // draw to x-axis
        ctx.strokeStyle = '#E1E1E1';
        ctx.stroke();
        ctx.restore();
      });
    });
  }
};
export const ColorEvolutionValues = {
  id: 'colorEvolutionValues',
  afterDatasetsDraw(chart) {
    const {
      ctx,
      scales,
      chartArea
    } = chart;
    const xScale = scales.x;
    const yScale = scales.y;

    // Get the evolution values and metric from the chart's data
    const {
      evolutionValues,
      metric
    } = chart.config.options;
    if (!evolutionValues || !evolutionValues.length || !metric || !metric.showEvolution) return;
    evolutionValues.forEach((evolution, index) => {
      if (!evolution) return;
      const x = xScale.getPixelForTick(index);
      const y = yScale.bottom + 45; // Position below the main label

      ctx.save();
      ctx.font = "12px Figtree, sans-serif";
      ctx.textAlign = "center";
      ctx.fillStyle = evolution.color;
      ctx.fillText(evolution.value, x, y);
      ctx.restore();
    });
  }
};